import * as Yup from 'yup';

export const SetNewPasswordSchema = Yup.object().shape({
  email: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Required'),
  password: Yup.string()
    .min(8, 'Password must be 8 characters long')
    .matches(/[0-9]/, 'Password requires a number')
    .matches(/^(?=.*[a-z])(?=.*[A-Z]).+$/, 'At least 1 uppercase & 1 lowercase letter')
    .matches(/[^\w]/, 'Password requires a symbol'),
  confirm: Yup.string()
    .oneOf([Yup.ref('password'), ''], 'Must match Password field value')
    .required('Required'),
});

export const validateNewPassword = (password = '') => {
  const isMinLength = password.length >= 8;
  const hasNumber = /[0-9]/.test(password);
  const hasMixedCase = /^(?=.*[a-z])(?=.*[A-Z]).+$/.test(password);
  const hasSpecialChar = /[^\w]/.test(password);

  return { isMinLength, hasNumber, hasMixedCase, hasSpecialChar };
};

export const validationRules = (password = '') => {
  const { isMinLength, hasMixedCase, hasNumber, hasSpecialChar } = validateNewPassword(password);

  return [
    {
      rule: isMinLength,
      text: 'At least 8 characters',
    },
    {
      rule: hasNumber,
      text: 'At least 1 number',
    },
    {
      rule: hasMixedCase,
      text: 'At least 1 uppercase & 1 lowercase letter',
    },
    {
      rule: hasSpecialChar,
      text: 'At least 1 special character',
    },
  ];
};
